<template>
  <div>
      <v-card :class="isMobile? 'pa-2':'pa-3'">
        <v-layout row wrap>
            <v-flex md3>
                <div style="width:100%;" class="text-md-left">
                    <img style="width:50px;height:50px;" :src="bankLogo">
                </div>
            </v-flex>                    
            <v-flex md9 align-self-center>
                <h4 style="padding-left:10px;">{{bankName}}</h4>
            </v-flex>
        </v-layout>
        <v-layout row wrap>
            <v-flex md6 sm2>
                Account NO.
            </v-flex>
            <v-flex md6 sm6 xs8 class="text-xs-left">
                <label style="color:blue;">{{helper.stringFormat.bankAccountNumber(accountNo)}}</label>
            </v-flex>
        </v-layout>   
        <v-layout row wrap>
            <v-flex md6>
                Account Name
            </v-flex>
            <v-flex md6 sm6 xs8 class="text-xs-left">
                {{accountName}}
            </v-flex>
        </v-layout>       
        <v-layout row wrap>
            <v-flex md6>
                Branch
            </v-flex>
            <v-flex md6 sm6 xs8 class="text-xs-left">
                {{branch}}
            </v-flex>
        </v-layout>       
        <v-layout row wrap>
            <v-flex md6>
                Account Type
            </v-flex>
            <v-flex md6 sm6 xs8 class="text-xs-left">
                {{accountType}}
            </v-flex>
        </v-layout>                        
                    

</v-card>   
  </div>
</template>

<script>
import Helper from '../helper';
import Common from '../common';

export default {
    props:[
        "bankCode",
        "bankName",
        "accountNo",
        "accountName",
        "branch",
        "accountType"
    ],
    computed:{
        bankLogo(){
            let logo = Helper.logos.banks.getByCode(this.bankCode.toLowerCase());
            return logo;
        },
        bank(){
            let bank = Common.banks.getByCode(this.bankCode);
            return bank;
        },
        isMobile(){
            return Helper.display.isMobile(this.$vuetify.breakpoint.name);
        },        
    },
    data(){
        return {
            helper:Helper,
        }
    }
}
</script>

<style>

</style>